function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M7 6h2v8H7V6zM11 6h2v8h-2V6z",
  fill: "#19496B"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10c-.006 5.52-4.48 9.994-10 10zm-8-9.828A8 8 0 102 10v.172z",
  fill: "#19496B"
});

var SvgBespokenPauseIcon = function SvgBespokenPauseIcon(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgBespokenPauseIcon;